import moment from 'moment'

export function formatTime(timestamp) {
  return moment(timestamp).format('YYYY-MM-DD hh:mm')
}